
import React from "react";
import Logo from "../../../assets/logos/logo_blanco_v++.svg"

function VisionFuturo() {
    return (
        <section className="empresa-vision">
            <div
                className="empresa-vision-graphic"
                aria-hidden="true"
            >
                <span className="empresa-vision-circle circle-one" />
                <span className="empresa-vision-circle circle-two" />
                <span className="empresa-vision-circle circle-three" />
                <span className="empresa-vision-center"><img src={Logo} alt="" width="80%"/></span>
                <span className="empresa-vision-coordinate">
          20°35&apos; N / 100°23&apos; W
        </span>
            </div>

            <div className="empresa-vision-content">
                <div className="empresa-section-label">
                    <span>03</span>
                    <span>MIRAMOS HACIA ADELANTE</span>
                </div>

                <span className="empresa-eyebrow">
                    VISIÓN DE FUTURO
                </span>

                <h2>
                    Miramos hacia
                    <br />
                    el futuro con
                    <br />
                    <span>determinación.</span>
                </h2>

                <p className="empresa-lead">
                    Convertir a Vemasmas en el principal referente
                    latinoamericano en innovación tecnológica.
                </p>

                <p>
                    Aspiramos a anticipar los desafíos del mañana
                    mediante soluciones efectivas y sostenibles,
                    impulsando el potencial de la tecnología para
                    abrir nuevos caminos.
                </p>
            </div>
        </section>
    );
}

export default VisionFuturo;
